export default "__VITE_ASSET__b0618cd9__"